import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const SITE = "https://loangorilla.com.au";

/**
 * Renders a canonical tag pointing to the destination URL, then performs
 * a client-side replace navigation. Used for alias paths so crawlers
 * fetching the alias URL see an explicit canonical → destination signal
 * (proper consolidation without noindex).
 */
export default function CanonicalRedirect({ to }: { to: string }) {
  const navigate = useNavigate();
  const { search, hash } = useLocation();

  useEffect(() => {
    navigate(`${to}${search}${hash}`, { replace: true });
  }, [navigate, to, search, hash]);

  const href = `${SITE}${to}`;
  return (
    <Helmet>
      <link rel="canonical" href={href} />
      <link rel="alternate" hrefLang="en-AU" href={href} />
      <link rel="alternate" hrefLang="x-default" href={href} />
      <meta property="og:url" content={href} />
    </Helmet>
  );
}
